(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["empire-bogo-gallery-sync"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('empire-bogo-gallery-sync')) {
    customElements.define('empire-bogo-gallery-sync', class EmpireBogoGallerySync extends HTMLElement {
      connectedCallback() {
        const dataElement = this.querySelector('[data-variant-media-map]');
        try {
          const variants = JSON.parse(dataElement?.textContent || '[]');
          this.variantMedia = new Map(variants.map((variant) => [String(variant.variantId), variant]));
        } catch (error) {
          this.variantMedia = new Map();
        }

        this.offer = this.closest('.product__info-container')?.querySelector('empire-bogo');
        this.handleChange = (event) => {
          const input = event.target.closest('input[type="radio"][name$="-primary"]');
          if (input) this.showVariantMedia(input.value);
        };

        this.offer?.addEventListener('change', this.handleChange);
        const selectedInput = this.offer?.querySelector('input[type="radio"][name$="-primary"]:checked');
        if (selectedInput) this.showVariantMedia(selectedInput.value);
      }

      disconnectedCallback() {
        this.offer?.removeEventListener('change', this.handleChange);
      }

      showVariantMedia(variantId) {
        const variant = this.variantMedia.get(String(variantId));
        if (!variant) return;

        const sectionId = this.dataset.sectionId;
        const gallery = document.getElementById(`MediaGallery-${sectionId}`);
        const mediaTarget = variant.mediaId ? `${sectionId}-${variant.mediaId}` : null;
        const mediaSlide = mediaTarget ? document.getElementById(`Slide-${mediaTarget}`) : null;

        if (gallery && mediaTarget && mediaSlide && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(mediaTarget, true);
          return;
        }

        const activeImage = gallery?.querySelector('.product__media-item.is-active img, .product__media-item img');
        if (activeImage && variant.imageUrl) {
          activeImage.src = variant.imageUrl;
          activeImage.srcset = '';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["empire-bogo-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('empire-bogo')) {
    customElements.define('empire-bogo', class EmpireBogo extends HTMLElement {
      connectedCallback() {
        this.offerInputs = [...this.querySelectorAll('input[type="radio"][name$="-offer"]')];
        this.primaryInputs = [...this.querySelectorAll('input[type="radio"][name$="-primary"]')];
        this.secondPicker = this.querySelector('[data-second-picker]');
        this.primarySelect = this.querySelector('[data-primary-variant-select]');
        this.primarySelectImage = this.querySelector('[data-primary-select-image]');
        this.secondarySelect = this.querySelector('[data-secondary-variant]');
        this.secondaryImage = this.querySelector('[data-secondary-image]');
        this.primaryTitle = this.querySelector('[data-primary-title]');
        this.submitButton = this.querySelector('[data-submit]');
        this.buyNowButton = this.querySelector('[data-buy-now]');
        this.error = this.querySelector('[data-error]');

        this.offerInputs.forEach((input) => input.addEventListener('change', () => this.updateOffer()));
        this.primaryInputs.forEach((input) => input.addEventListener('change', () => this.updatePrimary()));
        this.primarySelect?.addEventListener('change', () => this.updatePrimaryFromSelect());
        this.secondarySelect?.addEventListener('change', () => this.updateSecondaryImage());
        this.submitButton?.addEventListener('click', () => this.addToCart(false));
        this.buyNowButton?.addEventListener('click', () => this.addToCart(true));

        this.updateOffer();
        this.updatePrimary();
        this.updateSecondaryImage();
      }

      get selectedOffer() {
        return this.offerInputs.find((input) => input.checked)?.value || 'single';
      }

      get selectedPrimary() {
        return this.primaryInputs.find((input) => input.checked);
      }

      updateOffer() {
        this.offerInputs.forEach((input) => input.closest('.empire-bogo__offer')?.classList.toggle('is-selected', input.checked));
        if (this.secondPicker) this.secondPicker.hidden = this.selectedOffer !== 'bogo';
      }

      updatePrimary() {
        const primary = this.selectedPrimary;
        if (!primary) return;
        if (this.primaryTitle) this.primaryTitle.textContent = primary.dataset.variantTitle;
        if (this.submitButton) this.submitButton.disabled = primary.dataset.available !== 'true';
        if (this.buyNowButton) this.buyNowButton.disabled = primary.dataset.available !== 'true';
        if (this.primarySelect) this.primarySelect.value = primary.value;
        this.updatePrimarySelectImage();
      }

      updatePrimaryFromSelect() {
        const input = this.primaryInputs.find((primaryInput) => primaryInput.value === this.primarySelect?.value);
        if (!input) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updatePrimarySelectImage() {
        const option = this.primarySelect?.selectedOptions[0];
        if (!option || !this.primarySelectImage || !option.dataset.image) return;
        this.primarySelectImage.removeAttribute('srcset');
        this.primarySelectImage.removeAttribute('sizes');
        this.primarySelectImage.src = option.dataset.image;
        this.primarySelectImage.alt = option.textContent.trim();
      }

      updateSecondaryImage() {
        const option = this.secondarySelect?.selectedOptions[0];
        if (!option || !this.secondaryImage || !option.dataset.image) return;
        this.secondaryImage.removeAttribute('srcset');
        this.secondaryImage.removeAttribute('sizes');
        this.secondaryImage.src = option.dataset.image;
        this.secondaryImage.alt = option.textContent.trim();
      }

      async addToCart(goToCheckout) {
        const primary = this.selectedPrimary;
        const activeButton = goToCheckout ? this.buyNowButton : this.submitButton;
        if (!primary || !activeButton) return;

        const items = [{ id: Number(primary.value), quantity: 1 }];
        if (this.selectedOffer === 'bogo' && this.secondarySelect) {
          items.push({ id: Number(this.secondarySelect.value), quantity: 1 });
        }

        this.submitButton.disabled = true;
        this.buyNowButton.disabled = true;
        activeButton.classList.add('is-loading');
        if (this.error) this.error.hidden = true;

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.errorMessage);
          window.location.assign(goToCheckout ? this.dataset.checkoutUrl : this.dataset.cartUrl);
        } catch (error) {
          if (this.error) {
            this.error.textContent = error.message;
            this.error.hidden = false;
          }
          this.submitButton.disabled = false;
          this.buyNowButton.disabled = false;
          activeButton.classList.remove('is-loading');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
